// Console SPA — 简易 localStorage 包装（带 JSON 序列化）。

const SESSION_KEY = 'captcha_console_session_v1';

export interface StoredSession {
  token: string;
  /** 用户邮箱，用于顶栏显示 */
  email: string;
  /** 角色：owner / admin / operator / finance / viewer */
  role: string;
}

export function readSession(): StoredSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as StoredSession;
  } catch {
    return null;
  }
}

export function writeSession(s: StoredSession): void {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(s));
  } catch {
    /* quota / private mode — silently ignore */
  }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch {
    /* noop */
  }
}
